import React from 'react'

const HeaderActions = () => {
    return (
        <>
            <div className='me-3'>
                <button className='btn common-btn btn-blue-bg' type='button'>Login</button>
            </div>
            <div>
                <button className='btn common-btn' type='button'>Sign Up</button>
            </div>
        </>
    )
}

export default HeaderActions